import { PdaActModel } from "../models/sections/act";
import { PdaGeneralDataModel } from "../models/sections/general-data";
import { PdaPartyModel } from "../models/sections/party";
import { PctInfoFascicolo } from "../models/sections/pct-info-fascicolo";
import { PdaRegistryModel } from "../models/sections/registry";
import { PdaScheduleModel } from "../models/sections/schedule";
import { PdaRegister } from "../models/typological/pda-registers";
import { SectionsServiceTsService } from "../utils/Service/sections.service.ts.service";

export class PdaDataStore {
    private static _instance: PdaDataStore = new PdaDataStore();
    public modelActs: PdaActModel = null;
    public modelSchedules: PdaScheduleModel = null;
    public modelParty: PdaPartyModel = null;
    public modelGeneralData: PdaGeneralDataModel = null;
    public modelRegistry: PdaRegistryModel = null;
    public pctInfoFascicolo: PctInfoFascicolo = null;
    public pdaRegisters: PdaRegister[] = null;
    public idFascicoloTlf: string = null;

    private constructor() {
      if (PdaDataStore._instance) {
        return PdaDataStore._instance;
      }
      PdaDataStore._instance = this;
    }


    public static getInstance(): PdaDataStore {
      return PdaDataStore._instance;
    }

    public static isSameId(idFascicoloTlf: string){
      return PdaDataStore._instance.idFascicoloTlf == idFascicoloTlf;
    }

    public static cleanupStore(){
        PdaDataStore._instance.modelActs = null;
        PdaDataStore._instance.modelSchedules = null;
        PdaDataStore._instance.modelParty = null;
        PdaDataStore._instance.modelGeneralData = null;
        PdaDataStore._instance.pctInfoFascicolo = null;
        PdaDataStore._instance.idFascicoloTlf = null;
        PdaDataStore._instance.modelRegistry = null;

    }

  }
